import React, { useState, useEffect } from "react";
import { formatMoneda } from "../../util/varios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableFijo from "../useTableFijo";
import moment from "moment";
import { Mensaje, MensajeSiNo } from "../mensajes";
import { Dimmer } from "../spinner";

const headCells = [
  {
    id: "anio",
    label: "FECHA",
    width: "30px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "mes",
    label: "TIPO MULTA",
    width: "80px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "periodo",
    label: "CONCEPTO",
    width: "150px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "numrete",
    label: "MONTO",
    width: "150px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "montorete",
    label: "N° RECIBO",
    width: "150px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
  {
    id: "descristatus",
    label: "FECHA DE PAGOS",
    width: "150px",
    textAlign: "center",
    background: "#019cd5",
    fontSize: "10px",
    color: "white",
    disableSorting: true,
  },
];

const TablaHistoAgenteMulta = (props) => {
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar, setMostrar] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [contar, setContar] = useState(0);
  const [contar3, setContar3] = useState(0);
  const [activate, setActivate] = useState(false);
  const [idAgente, setIdAgente] = useState();
  const [periodo, setPeriodo] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  let op = require("../../../public/modulos/datos");

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableFijo(records, headCells, filterFn, 320);

  const [url, setUrl] = useState("");

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              ("R" || x.idfactura).includes(target.value) ||
              moment(x.fechaenterami)
                .format("DD/MM/YYYY")
                .includes(target.value) ||
              x.periodo.toLowerCase().includes(target.value.toLowerCase()) ||
              x.numrete
                .toString()
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              formatMoneda(
                x.montorete.toString().replace(".", ","),
                ",",
                ".",
                2
              ).includes(target.value) ||
              x.descristatus.includes(target.value)
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  useEffect(() => {
    if (props.tabreten) {
      setRecords(props.tabreten);
    }
  }, [props.tabreten]);

  /* useEffect(() => {

        if (contar === 0) {
            if (errorRet) {
                setActivate(false);
                let obj = JSON.parse(JSON.stringify(errorRet));

                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }


    }); */
  /* 
    const [DeleteReten, { loading: loadingRet, error: errorRet, data: dataRet }] = useMutation(FETCH_ELIMINAR_RETENCIONES_AGENTE_QUERY, {
        update(proxy, { data: { eliminarRetencionesAgente: dataRet } }) {
            setActivate(false);
            setRecords(dataRet.results);
            setTitulo("Advertencia");
            setMsg("Las retenciones del período " + periodo + " Fueron eliminadas con éxito.");
            setMostrar(true);
        }
    }); */

  const eliminarRetencion = (id, peri, status) => (event) => {
    if (status === "Por pagar" || status === "Rechazada") {
      setIdAgente(id);
      setPeriodo(peri);
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto:
          "Esta seguro de eliminar las Retenciones del período " + peri + " ?",
        icono: "confirmacion",
      });
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Advertencia",
        texto:
          "No se puede eliminar la Retenciones por que se encuentra " +
          status +
          ".",
        icono: "informacion",
      });
    }
  };

  const handleCloseNo = () => {
    setMostrar3(false);
  };

  const handleCloseSi = () => {
    setContar(0);
    setActivate(true);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    /*  DeleteReten({
            variables: {
                idcomer: idAgente,
                peri: periodo
             
            }
        }); */
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  const imprimirRetencion = (factura) => (event) => {
    event.preventDefault();

    //var reporte ='PlanillaRetencionAraure';
    var reporte = "PlanillaRetencionAcarigua";

    window.open(
      op.reportes +
        "reporte=" +
        reporte +
        "&id=" +
        factura.trim() +
        "&viene=" +
        props.espiritu +
        "&factura=" +
        factura.replace("R", ""),
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    );
  };

  return (
    <div className="card">
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} />
      <div className="card-body">
        <div className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12 mx-auto d-flex justify-content-end">
                <div className="col-sm-2 d-flex justify-content-end py-1">
                  <button
                    className="btn btn-sm btn-primary px-2  rounded-circle"
                    title="Imprimir"
                  >
                    <i className="fas fa-print"> </i>{" "}
                  </button>
                </div>
              </div>
              <div className="col-md-12">
                <TblContainer>
                  <TblHead />

                  <TableBody>
                    {records &&
                      records.map((item, index) => (
                        <TableRow
                          key={item.idfactura + item.periodo}
                          style={{ padding: "0" }}
                        >
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment(item.fechamulta).format("YYYY-MM-DD")}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.tipomulta}{" "}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {item.concepto}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {formatMoneda(
                              item.monto.toString().replace(".", ","),
                              ",",
                              ".",
                              2
                            )}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "right" }}
                          >
                            {item.recibo}
                          </TableCell>
                          <TableCell
                            style={{ fontSize: "10px", textAlign: "center" }}
                          >
                            {moment(item.fechapago).format("YYYY-MM-DD")}
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
                {/*<TblPagination />*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TablaHistoAgenteMulta;



// WEBPACK FOOTER //
// ./src/components/multas/historicoAgentes.js